import React, { useState } from "react";
import Button from "../../components/Button";
import CardLayout from "../../components/CardLayout";
import Input from "../../components/Input";

const UpdateWallet = () => {
  const [data, setData] = useState({
    wallet_address: "",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(data);
  };
  return (
    <div className="mono_updatewallet_page_wrapper">
      <CardLayout
        style={{ backgroundColor: "#fff" }}
        className="mono_updatewallet_card"
      >
        <div className="mono_updatewallet_title">
          <h2>update wallet</h2>
        </div>
        <div className="mono_updatewallet_field">
          <form onSubmit={handleSubmit}>
            <div className="form_group">
              <Input
                label="Tron (TRX) receiving address"
                type="text"
                value={data.wallet_address}
                name="wallet_address"
                onChange={(e) =>
                  setData({ ...data, wallet_address: e.target.value })
                }
                placeholder="Enter tron receiving address"
              />
            </div>
            <Button type="submit" className="updatewallet_btn">
              update wallet
            </Button>
          </form>
        </div>
      </CardLayout>
    </div>
  );
};

export default UpdateWallet;
